import React from 'react';
import {
    ChatContainer,
    ChatWrapper,
    ChatH1,
    ChatP,
    ChatWrapperFrame,
    Iframe
} from './ChatWithUsElements';

const ChatWithUsComponent = () => {
    return (
        <ChatContainer>
            <ChatWrapper>
                <ChatH1>Contact Us</ChatH1>
                <ChatP>
                    We will get back to you as soon as possible.
                </ChatP>
                <ChatWrapperFrame>
                    <Iframe src="https://links.collect.chat/61148ef336b5b233b034898e" />
                </ChatWrapperFrame>
            </ChatWrapper>
        </ChatContainer>
    );
};

export default ChatWithUsComponent;
